function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import Common from "../components/includes/Common";
import { Alert, Skeleton, Button, Drawer, Image, Form, Input, Select } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import { GeoAltFill, PlayCircleFill, CollectionPlayFill, Sliders } from "react-bootstrap-icons";
import MomentsView from "../components/MomentsView";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Media = function Media() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showMoments = _useState2[0],
    setShowMoments = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    feed = _useState4[0],
    setFeed = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedEvent = _useState6[0],
    setSelectedEvent = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isFeedLoading = _useState8[0],
    setIsFeedLoading = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isMoreFeedLoading = _useState10[0],
    setIsMoreFeedLoading = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    errorMessage = _useState12[0],
    setErrorMessage = _useState12[1];
  var _useOutletContext = useOutletContext(),
    handleNewTicket = _useOutletContext.handleNewTicket;
  var _useOutletContext2 = useOutletContext(),
    handleShowEventDetails = _useOutletContext2.handleShowEventDetails;
  var _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    countryId = _useState14[0],
    setCountryId = _useState14[1];
  var _useState15 = useState(0),
    _useState16 = _slicedToArray(_useState15, 2),
    eventCategoryId = _useState16[0],
    setEventCategoryId = _useState16[1];
  var _useState17 = useState(2),
    _useState18 = _slicedToArray(_useState17, 2),
    eventType = _useState18[0],
    setEventType = _useState18[1];
  var _useState19 = useState(0),
    _useState20 = _slicedToArray(_useState19, 2),
    month = _useState20[0],
    setMonth = _useState20[1];
  var _useState21 = useState(""),
    _useState22 = _slicedToArray(_useState21, 2),
    keyword = _useState22[0],
    setKeyword = _useState22[1];
  var _useState23 = useState(8),
    _useState24 = _slicedToArray(_useState23, 2),
    limit = _useState24[0],
    setLimit = _useState24[1];
  var _useState25 = useState(0),
    _useState26 = _slicedToArray(_useState25, 2),
    offset = _useState26[0],
    setOffset = _useState26[1];
  var _useState27 = useState([]),
    _useState28 = _slicedToArray(_useState27, 2),
    countries = _useState28[0],
    setCountries = _useState28[1];
  var _useState29 = useState([{
      value: 0,
      label: "Toutes"
    }]),
    _useState30 = _slicedToArray(_useState29, 2),
    eventCategories = _useState30[0],
    setEventCategories = _useState30[1];
  var _useState31 = useState([{
      value: 2,
      label: "Tout"
    }, {
      value: 0,
      label: "Gratuit"
    }, {
      value: 1,
      label: "Payant"
    }]),
    _useState32 = _slicedToArray(_useState31, 2),
    eventTypes = _useState32[0],
    setEventTypes = _useState32[1];
  var loadMore = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsMoreFeedLoading(true);
            setOffset(offset + limit);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function loadMore() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    axios.post("".concat(Common.baseApiUrl, "geteventshavingmoments"), {
      country_id: countryId,
      event_category_id: eventCategoryId,
      keyword: keyword,
      month: month,
      limit: limit,
      offset: offset
    }).then(function (response) {
      if (response.data.status == 200) {
        setFeed(response.data.events);
      } else {
        setErrorMessage("Une erreur est survenue pendant le chargement");
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue pendant le chargement");
    })["finally"](function () {
      setIsFeedLoading(false);
    });
  }, []);
  useEffect(function () {
    form.setFieldsValue({
      category_id: 0,
      event_type: 0
    });
    axios.all([axios.get(Common.baseApiUrl + 'getcountries'), axios.get(Common.baseApiUrl + 'geteventcategories')]).then(function (response) {
      if (response[0].data.status == 200) {
        setCountries([]);
        response[0].data.countries.forEach(function (c) {
          setCountries(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: "".concat(c.label)
            }]);
          });
        });
        if (response[0].data.countries.length > 0) {
          form.setFieldsValue({
            country_id: response[0].data.countries[0].id
          });
          setCountryId(response[0].data.countries[0].id);
        }
      }
      if (response[1].data.status == 200) {
        setEventCategories([{
          value: 0,
          label: "Toutes"
        }]);
        response[1].data.categories.forEach(function (c) {
          setEventCategories(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: "".concat(c.label, " (").concat(c.events.length, ")")
            }]);
          });
        });
      }
    })["catch"](function (error) {
      console.log('Erreur pendant le chargement');
    });
  }, [offset]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 3,
          md: 3,
          children: /*#__PURE__*/_jsx("div", {
            style: {
              padding: "13px",
              borderRadius: "5px",
              minHeight: "300px"
            },
            children: /*#__PURE__*/_jsxs("div", {
              className: "feed-box",
              style: {
                background: "#F3F2EC"
              },
              children: [/*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Filtre"
                })
              }), /*#__PURE__*/_jsxs(Form, {
                layout: "vertical",
                form: form,
                onFinish: function onFinish(values) {
                  setEventCategoryId(0);
                  setLimit(8);
                  setOffset(0);
                  setCountryId(values.country_id);
                  setEventCategoryId(values.category_id);
                  setEventType(values.event_type);
                },
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  name: "country_id",
                  label: "Pays",
                  children: /*#__PURE__*/_jsx(Select, {
                    options: countries
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "category_id",
                  label: "Cat\xE9gorie",
                  children: /*#__PURE__*/_jsx(Select, {
                    options: eventCategories
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  name: "event_type",
                  label: "Types d'\xE9v\xE8nements",
                  children: /*#__PURE__*/_jsx(Select, {
                    options: eventTypes
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    type: "default",
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsxs("b", {
                      children: [" ", /*#__PURE__*/_jsx(Sliders, {
                        size: 17
                      }), " Filtrer"]
                    })
                  })
                })]
              })]
            })
          })
        }), /*#__PURE__*/_jsxs(Col, {
          lg: 9,
          md: 9,
          children: [/*#__PURE__*/_jsx(Image, {
            src: "drawables/1.png",
            preview: false,
            style: {
              borderRadius: "7px ",
              marginBottom: "10px"
            }
          }), isFeedLoading ? /*#__PURE__*/_jsx(Skeleton, {
            active: true
          }) : /*#__PURE__*/_jsx(Row, {
            children: feed.map(function (e) {
              return /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                sm: 6,
                children: /*#__PURE__*/_jsx("div", {
                  className: "m-e-box",
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 3,
                      md: 3,
                      sm: 4,
                      xs: 4,
                      children: /*#__PURE__*/_jsx(Image, {
                        preview: false,
                        src: e.image_file,
                        width: "90px",
                        height: "90px",
                        style: {
                          borderRadius: "90px"
                        }
                      })
                    }), /*#__PURE__*/_jsxs(Col, {
                      children: [/*#__PURE__*/_jsx("h6", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: e.label
                        })
                      }), /*#__PURE__*/_jsx("p", {
                        children: /*#__PURE__*/_jsxs("b", {
                          children: [/*#__PURE__*/_jsx(GeoAltFill, {
                            size: 22
                          }), " ", e.place]
                        })
                      }), /*#__PURE__*/_jsx("div", {
                        style: {
                          textAlign: 'center'
                        },
                        children: /*#__PURE__*/_jsx(Button, {
                          type: "primary",
                          onClick: function onClick() {
                            setSelectedEvent(e);
                            setShowMoments(true);
                          },
                          children: /*#__PURE__*/_jsxs("b", {
                            children: [/*#__PURE__*/_jsx(PlayCircleFill, {
                              size: 22
                            }), "REPLAY"]
                          })
                        })
                      }), /*#__PURE__*/_jsx("br", {})]
                    })]
                  })
                })
              }, e.id);
            })
          })]
        })]
      })
    }), selectedEvent != null && /*#__PURE__*/_jsx(Drawer, {
      open: showMoments,
      onClose: function onClose() {
        setShowMoments(false);
      },
      title: /*#__PURE__*/_jsxs("b", {
        children: [/*#__PURE__*/_jsx(CollectionPlayFill, {
          size: 25
        }), " ", selectedEvent.label]
      }),
      destroyOnClose: true,
      width: "95%",
      maskClosable: false,
      children: /*#__PURE__*/_jsx(MomentsView, {
        event: selectedEvent
      })
    })]
  });
};
export default Media;